import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useEnrichmentStatusFilter } from './useEnrichmentStatusFilter';

export const EnrichmentStatusFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, enrichmentStatusOptions } = useEnrichmentStatusFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ enrichmentStatus: value || enrichmentStatusOptions[0] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="enrichmentStatus"
          label="Enrichment status"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={enrichmentStatusOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

EnrichmentStatusFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

EnrichmentStatusFilter.defaultProps = {
  value: null,
};
